var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FrsModuleRoot',{attrs:{"module":_vm.module,"module-path":['fieldRecordSystem', 'mapManagement'],"translation-namespaces":['mm', 'frs.maps.zoneMap'],"setup":_vm.loadAllMaps,"persistent":""}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }